import Bind from 'bind.js';

export default class BuyNow {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.addContent();
  }

  addContent() {
    let template = `
      <div class="map">
      </div>
    `

    this.parentElement.insertAdjacentHTML("afterbegin", template);

    this.editor = Bind(
      {
        url: this.data.get('url')
      },
      {
        url: {
          dom: '.map',
          transform:function(val) {
            return `
              <iframe src="${val}"
                    frameborder="0" style="border:0" allowfullscreen></iframe>
            `
          }
        }
      }
    );
  }

  reRender(data) {
    this.data = data;
    this.editor.url = data.get('url');
  }
}



// WEBPACK FOOTER //
// ./src/renderers/Map.js